export default __webpack_public_path__ + "static/media/HomepageBuildCard.905f010c.png";